/**
 * The tab's title: the route's own, unless a screen standing in for the route holds one, as
 * Start does for an account without counties on whatever address it opened.
 */
let routeTitle = "EstateLark";
let held: string | null = null;

/** The router calls this on every change of route. */
export function setRouteTitle(title: string | undefined) {
  routeTitle = title ? `${title} | EstateLark` : "EstateLark";
  document.title = held ?? routeTitle;
}

/** Holds a title while a screen is shown; null gives the route's back. */
export function holdTitle(title: string | null) {
  held = title;
  document.title = held ?? routeTitle;
}
